import { motion } from "framer-motion";
import { Landmark, ShoppingBag, Building2 } from "lucide-react";

const EnvironnementsSection = () => {
  const environnements = [
    {
      title: "Banque & Finance",
      description: "Contraintes réglementaires fortes, sécurité maximale",
      icon: <Landmark className="w-6 h-6 text-lenvia-blue" />
    },
    {
      title: "Retail & E-commerce",
      description: "Pics de charge, performance temps réel",
      icon: <ShoppingBag className="w-6 h-6 text-lenvia-blue" />
    },
    {
      title: "Secteur Public",
      description: "Souveraineté, accessibilité, conformité",
      icon: <Building2 className="w-6 h-6 text-lenvia-blue" />
    }
  ];

  return (
    <section className="section-spacing relative">
      {/* Background - LIGHTER */}
      <div className="absolute inset-0 bg-[#070B1A]" />
      <div className="absolute inset-0 bg-gradient-to-t from-transparent via-lenvia-blue/[0.03] to-transparent" />
      
      <div className="lenvia-container relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="inline-flex items-center gap-2.5 mb-6"
          >
            <Building2 className="w-4 h-4 text-lenvia-blue" />
            <span className="text-xs font-bold tracking-[0.2em] text-slate-400 uppercase">
              Secteurs d'intervention
            </span>
          </motion.div>
          
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="font-heading text-3xl md:text-4xl lg:text-[2.75rem] font-bold tracking-tight text-white mb-5"
          >
            Nos environnements de{" "}
            <span className="gradient-text">prédilection</span>
          </motion.h2>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
            className="text-base text-slate-400"
          >
            Interventions sur des systèmes à forte criticité et exigences réglementaires élevées
          </motion.p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {environnements.map((env, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="glass-card p-8 flex flex-col items-center text-center h-full">
                {/* Icon */}
                <div className="icon-container-lg mb-6 group-hover:scale-110 transition-transform duration-300">
                  {env.icon}
                </div>
                
                {/* Content */}
                <h3 className="font-heading text-xl font-bold text-white mb-4">
                  {env.title}
                </h3>
                <p className="text-base text-slate-400 leading-relaxed">
                  {env.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EnvironnementsSection;
